/* eslint-disable max-len */
import { AxiosPromise } from "axios";
import { AppApiResponseData } from "../types/api";
import http from './http'

export function getChartsData(
	patientId: string,
	startTimeMinutes: any,
	endTimeMinutes: any
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'GET',
		url: `https://staging-engage.dariohealth.com/api/v1/dario/${patientId}/events/charts?start_time=@${startTimeMinutes}&end_time=@${endTimeMinutes}`
	})
}

export function getPainLevelChartData(
	patientId: string,
	startTimeMinutes: any,
	endTimeMinutes: any
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'GET',
		url: `https://staging-engage.dariohealth.com/api/v1/msk/user/${patientId}/pain-level?start_time=${startTimeMinutes}&end_time=${endTimeMinutes}`,
	})
}

